import CircularProgress, { CircularProgressProps } from "@material-ui/core/CircularProgress";
import React, { FC } from "react";

import classes from "./Loader.module.scss";

type LoaderProps = {
  top?: string;
  isAbsolutePosition?: boolean;
  size?: number;
};

const Loader: FC<LoaderProps & CircularProgressProps> = ({ top, isAbsolutePosition = true, size, ...rest }) => {
  return (
    <CircularProgress
      style={
        top
          ? {
              top,
            }
          : size
          ? {
              top: `${size}px`,
            }
          : {
              ...rest.style,
            }
      }
      className={isAbsolutePosition ? classes.absoluteLoader : ""}
      size={size || 63}
      {...rest}
    />
  );
};

export default Loader;
